import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { ContextoGeral } from '../../contextos/ContextoGeral'
import { indicacaoModuloDisponivel } from '../../utils/indicacaoModulo'

export default function RotaModuloIndicacao({ children }) {
	const { dados } = useContext(ContextoGeral)

	if (!indicacaoModuloDisponivel(dados)) {
		return <Navigate to="/app/home" replace />
	}

	return children
}
